// extracted by mini-css-extract-plugin
export default {"add-shadow":"About_add-shadow__3ORXv","toolTip":"About_toolTip__jSGlG","wrapper":"About_wrapper__CA1FO","contents":"About_contents__IWreI"};